import intermind, { Prompt } from '../../index';
import { AskChat, AskMessage, SendAskMessageRequest } from './types';

export class AskResource {
  async getChats(userId: string): Promise<AskChat[]> {
    const { data } = await intermind.httpClient.get<AskChat[]>(`/ask/chats?userId=${userId}`);
    return data;
  }

  async getMessages(userId: string, chatId: string): Promise<AskMessage[]> {
    const { data } = await intermind.httpClient.get<AskMessage[]>(`/ask/chats/${chatId}/messages?userId=${userId}`);
    return data;
  }

  async sendMessage(params: SendAskMessageRequest): Promise<AskMessage> {
    const { data } = await intermind.httpClient.post<AskMessage>('/ask/chats/messages', params);
    return data;
  }

  async transferChats(sourceUserId: string): Promise<void> {
    await intermind.httpClient.post('/ask/chats/transfer', { sourceUserId });
  }

  async getPredefinedPrompts(): Promise<Prompt[]> {
    const { data } = await intermind.httpClient.get<Prompt[]>('/ask/prompts');
    return data;
  }
}
